import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';

export interface IAuditLog {
  gid: number;
  eid: number;
  source: number;
  seqid: number;
  dateTime: string;
  atype: number;
  entid: number;
  uid: number;
  period: number;
  code: number;
  beforedata: string;
  afterdata: string;
}

export interface IAuditsResponse extends ApiResponse {
  list: IAuditLog[];
  totalRows: number;
}

export const fetchAuditLogs = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  eid?: number,
  begin?: string | null,
  end?: string
): Promise<AxiosResponse<IAuditsResponse>> => {
  const url =
    `${zps_ms_ea_war}/audit?offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (eid ? `&eid=${eid}` : '') +
    (begin ? `&begin=${begin}` : '') +
    (end ? `&end=${end}` : '');

  return axios.get<IAuditsResponse>(url, {
    signal: controller.signal
  });
};
